import { clsx } from 'clsx'
import { CSSProperties, ReactNode } from 'react'
import { getLineHeight, styles } from 'util/style'
import css from './Typo.module.scss'

type Props = {
  accent?: boolean
  balance?: boolean
  bold?: boolean
  center?: boolean
  children?: ReactNode
  className?: string
  code?: boolean
  ellipsis?: boolean
  error?: boolean
  first?: boolean
  line?: number
  medium?: boolean
  mono?: boolean
  normal?: boolean
  nowrap?: boolean
  one?: boolean
  pre?: boolean
  primary?: boolean
  secondary?: boolean
  semi?: boolean
  size?: number
  style?: CSSProperties
  tertiary?: boolean
  title?: string
  upper?: boolean
  weight?: number
  wrap?: boolean
  dashed?: boolean
  dotted?: boolean
}

export function Typo(props: Props) {
  const {
    accent,
    balance,
    bold,
    center,
    children,
    code,
    ellipsis,
    error,
    first,
    line,
    medium,
    mono,
    normal,
    nowrap,
    one,
    pre,
    primary,
    secondary,
    semi,
    size,
    tertiary,
    title,
    upper,
    weight,
    wrap,
    dashed,
    dotted,
  } = props

  const className = clsx(
    props.className,
    css.typo,
    accent ? 'font-accent' : 'font-regular',
    normal && css.normal,
    medium && css.medium,
    semi && css.semi,
    bold && css.bold,
    mono && css.mono,
    center && css.center,
    one && css.one,
    upper && css.upper,
    code && css.code,
    pre && css.pre,
    nowrap && css.nowrap,
    wrap && css.wrap,
    balance && css.balance,
    primary && css.primary,
    ellipsis && css.ellipsis,
    error && css.error,
    first && css.first,
    secondary && css.secondary,
    tertiary && css.tertiary,
    dashed && css.dashed,
    dotted && css.dotted
  )

  const fontSize = size
  const fontWeight = weight
  const lineHeight = getLineHeight(line)
  const style = styles({ fontSize, fontWeight, lineHeight, ...props.style })

  return (
    <span className={className} style={style} title={title}>
      {children}
    </span>
  )
}
